// doc: https://router.vuejs.org/ru/
import Vue from 'vue'
import Router from 'vue-router'
import web from './web'

Vue.use(Router)

export function createRouter () {
    return new Router({
        mode: 'history',
        fallback: false,
        base: '',

        routes: [
            {
                path: '/',
                name: 'main',
                component: () => import('@/views/main')
            },
            {
                path: '/session',
                name: 'session',
                component: () => import('@/views/session')
            },

            ...web
        ],

        scrollBehavior () {
            return {x: 0, y: 0}
        }
    })
}
